// Permission constants

// Credit Memo permissions
export const PERMISSION_CREDIT_MEMO_CREATE = "credit-memo.create";
export const PERMISSION_CREDIT_MEMO_VIEW = "credit-memo.view";
export const PERMISSION_CREDIT_MEMO_DELETE = "credit-memo.delete";
export const PERMISSION_CREDIT_MEMO_EDIT = "credit-memo.edit";
export const PERMISSION_CREDIT_MEMO_LIST = "credit-memo.list";

// Payments permissions
export const PERMISSION_PAYMENTS_CREATE = "payments.create";
export const PERMISSION_PAYMENTS_VIEW = "payments.view";
export const PERMISSION_PAYMENTS_DELETE = "payments.delete";
export const PERMISSION_PAYMENTS_EDIT = "payments.edit";
export const PERMISSION_PAYMENTS_LIST = "payments.list";

// Products permissions
export const PERMISSION_PRODUCTS_LIST = "products.list";
export const PERMISSION_PRODUCTS_CREATE = "products.create";
export const PERMISSION_PRODUCTS_VIEW = "products.view";
export const PERMISSION_PRODUCTS_EDIT = "products.edit";
export const PERMISSION_PRODUCTS_STATUS_EDIT = "products.status.edit";
export const PERMISSION_PRODUCTS_COST_VIEW = "products.cost.view";
export const PERMISSION_PRODUCTS_COST_EDIT = "products.cost.edit";
export const PERMISSION_PRODUCTS_SEGMENTS_VIEW = "products.segments.view";
export const PERMISSION_PRODUCTS_SEGMENTS_EDIT = "products.segments.edit";
export const PERMISSION_PRODUCTS_SEGMENTS_DELETE = "products.segments.delete";
export const PERMISSION_PRODUCTS_UNIT_TYPES_EDIT = "products.unit-types.edit";
export const PERMISSION_PRODUCTS_UNIT_TYPES_CREATE = "products.unit-types.create";
export const PERMISSION_PRODUCTS_UNIT_TYPES_DELETE = "products.unit-types.delete";
export const PERMISSION_PRODUCTS_DELETE = "products.delete";

// Inventory permissions
export const PERMISSION_INVENTORY_VIEW = "inventory.view";
export const PERMISSION_INVENTORY_EDIT = "inventory.edit";

// Orders permissions
export const PERMISSION_ORDER_PRODUCTS_ADD = "order.products.add";
export const PERMISSION_ORDER_PRODUCTS_DELETE = "order.products.delete";
export const PERMISSION_ORDER_PRODUCTS_EDIT = "order.products.edit";
export const PERMISSION_ORDER_PRODUCTS_PRICE_EDIT = "order.products.price.edit";
export const PERMISSION_ORDER_PRODUCTS_DISCOUNT_EDIT = "order.products.discount.edit";
export const PERMISSION_ORDER_PRODUCTS_STATUS_EDIT = "order.status.edit";
export const PERMISSION_ORDER_SEGMENT_EDIT_ON_CREATION = "order.segment.edit-on-creation";
export const PERMISSION_ORDER_SEGMENT_EDIT_ON_DETAIL = "order.segment.edit-on-detail";

/** Scheduled deliveries (SELL_OUT sub-deliveries): list page + sidebar */
export const PERMISSION_ORDER_SCHEDULED_DELIVERIES_LIST = "order.scheduled-deliveries.list";
/** Panel on purchase detail (balances + history) */
export const PERMISSION_ORDER_SCHEDULED_DELIVERIES_DETAIL = "order.scheduled-deliveries.detail";
export const PERMISSION_ORDER_SCHEDULED_DELIVERIES_CREATE = "order.scheduled-deliveries.create";
/** Edit delivery lines/date, tracking, and status transitions */
export const PERMISSION_ORDER_SCHEDULED_DELIVERIES_EDIT = "order.scheduled-deliveries.edit";
export const PERMISSION_ORDER_SCHEDULED_DELIVERIES_DELETE = "order.scheduled-deliveries.delete";

// Purchases permissions
export const PERMISSION_PURCHASES_USER_EDIT_ON_CREATION = "purchases.user.edit-on-creation";
export const PERMISSION_PURCHASES_USER_EDIT_ON_DETAIL = "purchases.user.edit-on-detail";
export const PERMISSION_PURCHASE_INVOICED_EDIT = "action.purchase.invoiced.edit";

// Routes permissions
export const PERMISSION_ROUTES_LIST_ALL = "action.routes.list-all";

// Clients permissions
export const PERMISSION_CLIENTS_FOLLOW_UP_LIST = "clients.follow-up.list";
export const PERMISSION_CLIENTS_EDIT = "clients.edit";
export const PERMISSION_CLIENTS_DELETE = "clients.delete";

// Customer service permissions
export const PERMISSION_CUSTOMER_SERVICE_OWN_MESSAGES_ONLY = "customer-service.own-messages-only";
